// @flow
export const IfElse = ({ test, ifContent, elseContent }) => {
  return test ? ifContent : elseContent;
};
